<admin-app-header></admin-app-header>

<div *ngIf="exceptionAlerts">
    <div class="container-fluid">
        <div class="row py-2">
            <div class="col-lg-4">
                <h2 class="float-start d-inline-block">Exception Alerts</h2>
                <select class="form-select float-end" (change)="onReviewedChange($event)" [ngModel]="reviewed" style="width: 200px">
                    <option value="true">Reviewed</option>
                    <option value="false">Unreviewed</option>
                </select>
            </div>
            <div class="col-lg-8">
                <button (click)="markAllAsReviewed()" class="btn btn-success btn-sm text-white float-end px-3 py-1 my-2"><i class="fas fa-check-double"></i> Mark All as Reviewed</button>
            </div>
        </div>

        <div class="content col-lg-12">
            <table class="table table-striped table-hover table-sm" id="all-exception-alerts">
                <thead>
                    <tr>
                        <th scope="col">Timestamp</th>
                        <th scope="col">Severity</th>
                        <th scope="col">Message</th>
                        <th scope="col">Function</th>
                        <th scope="col">File</th>
                        <th scope="col">Line</th>
                        <th scope="col">Reviewed</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let alert of exceptionAlerts">
                        <td>{{ alert.timestamp | date: 'medium' }}</td>
                        <td>
                            <span [ngClass]="getSeverityClass(alert.alertSeverity)" class="badge">
                                {{ alert.alertSeverity }}
                            </span>
                        </td>
                        <td>
                            <a (click)="viewExceptionDetails(alert)" class="text-decoration-none cursor-pointer"> {{ alert.comment }} {{ alert.message }} </a>
                            <ng-container *ngIf="alert.json">
                                <i class="fas fa-database" title="Has JSON data"></i>
                            </ng-container>
                        </td>
                        <td>{{ alert.functionName }}</td>
                        <td>{{ alert.fileName }}</td>
                        <td>{{ alert.lineNumber }}</td>
                        <td>
                            <span [ngClass]="{ 'text-success': alert.reviewed, 'text-danger': !alert.reviewed }">
                                {{ alert.reviewed ? 'Yes' : 'No' }}
                            </span>
                        </td>
                        <td>
                            <a *ngIf="!alert.reviewed" (click)="markAsReviewed(alert.$key!)" class="badge bg-success text-white px-3 py-1 my-2"><i class="fas fa-check-double"></i> Mark as Reviewed</a>
                            <a *ngIf="alert.reviewed" (click)="markAsUnreviewed(alert.$key!)" class="badge bg-danger text-white px-3 py-1 my-2"
                                ><i class="fas fa-times-circle"></i> Mark as Unreviewed</a
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Exception Detail Modal -->
<ng-template #exceptionDetailModal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">
                <i class="fa fa-exclamation-triangle me-2"></i>
                Exception Details
            </h4>
            <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="selectedExceptionAlert">
            <div class="row">
                <div class="col-md-8">
                    <h5>{{ selectedExceptionAlert.message }}</h5>
                </div>
                <div class="col-md-4 text-end">
                    <span [ngClass]="getSeverityClass(selectedExceptionAlert.alertSeverity)" class="badge fs-6">
                        {{ selectedExceptionAlert.alertSeverity }}
                    </span>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-6">
                    <strong>Timestamp:</strong><br />
                    {{ selectedExceptionAlert.timestamp | date: 'medium' }}
                </div>
                <div class="col-md-6">
                    <strong>Reviewed:</strong><br />
                    <span [ngClass]="{ 'text-success': selectedExceptionAlert.reviewed, 'text-danger': !selectedExceptionAlert.reviewed }">
                        {{ selectedExceptionAlert.reviewed ? 'Yes' : 'No' }}
                    </span>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-6">
                    <strong>Function:</strong><br />
                    {{ selectedExceptionAlert.functionName }}
                </div>
                <div class="col-md-6">
                    <strong>File:</strong><br />
                    {{ selectedExceptionAlert.fileName }}:{{ selectedExceptionAlert.lineNumber }}
                </div>
            </div>

            <div class="row mt-3" *ngIf="selectedExceptionAlert.comment">
                <div class="col-12">
                    <strong>Comments:</strong><br />
                    {{ selectedExceptionAlert.comment }}
                </div>
            </div>

            <div class="row mt-3" *ngIf="selectedExceptionAlert.stackTrace">
                <div class="col-12">
                    <strong>Stack Trace:</strong>
                    <pre class="bg-light p-3 border rounded mt-2" style="max-height: 200px; overflow-y: auto"><code>{{ selectedExceptionAlert.stackTrace }}</code></pre>
                </div>
            </div>

            <div class="row mt-3" *ngIf="selectedExceptionAlert.json">
                <div class="col-12">
                    <strong>JSON Data:</strong>
                    <pre class="bg-light p-3 border rounded mt-2" style="max-height: 300px; overflow-y: auto"><code>{{ getFormattedJson(selectedExceptionAlert.json) }}</code></pre>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            <button type="button" class="btn btn-primary me-2" (click)="markAsReviewed(selectedExceptionAlert!.$key!); closeModal()" *ngIf="!selectedExceptionAlert?.reviewed">Mark as Reviewed</button>
            <button type="button" class="btn btn-warning" (click)="markAsUnreviewed(selectedExceptionAlert!.$key!); closeModal()" *ngIf="selectedExceptionAlert?.reviewed">Mark as Unreviewed</button>
        </div>
    </div>
</ng-template>
